// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vts-skip{position:fixed;z-index:1000;inset-block-start:0;inset-inline-start:-10000px;border:3px solid;padding:.5rem;color:#000;background-color:#fff}.vts-skip:focus{inset-inline-start:0}", ""]);
// Exports
module.exports = exports;
